<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import "carbon-components-svelte/css/all.css";
  import {
    CodeSnippet,
    Column,
    Grid,
    LocalStorage,
    RadioButtonGroup,
    RadioButton,
    Row,
    TextArea,
    Tile,
  } from "carbon-components-svelte";
  import ArrowShiftDown16 from "carbon-icons-svelte/lib/ArrowShiftDown16/ArrowShiftDown16.svelte";

  export let core;
  export let params = {}; // to surpress the warning message from Router

  const dispatch = createEventDispatcher();

  let text: string = "Hello";
  let color: string = "yellow";
  $: converted = core.convert_to_slack_alphabet_pack_emoji(text, color);
  $: preview = core.generate_preview_html(converted);

  onMount(() => {
    dispatch("routeEvent", { component: "DirectInput" });
  });
</script>

<Grid>
  <Row>
    <Column>
      <TextArea labelText="Input" bind:value={text} autofocus />
      <LocalStorage key="direct-input-text" bind:value={text} />
    </Column>
  </Row>
  <Row>
    <Column>
      <RadioButtonGroup legendText="Text color" bind:selected={color}>
        <RadioButton labelText="Yellow" value="yellow" />
        <RadioButton labelText="White" value="white" />
      </RadioButtonGroup>
      <LocalStorage key="direct-input-color" bind:value={color} />
    </Column>
  </Row>
  <Row>
    <Column>
      <ArrowShiftDown16 style="width:100%" />
    </Column>
  </Row>
  <Row>
    <Column md={6}>
      <p class="bx--label">Converted</p>
      <CodeSnippet type="multi" bind:code={converted} style="max-width: 100%" />
    </Column>
    <Column md={2}>
      <iframe
        title="Advertisement"
        src="https://rcm-fe.amazon-adsystem.com/e/cm?o=9&p=9&l=ez&f=ifr&linkID=f1f66cfc0b10822984ab3bb43f425151&t=0xb17bea125-22&tracking_id=0xb17bea125-22"
        width="180"
        height="150"
        scrolling="no"
        border="0"
        marginwidth="0"
        style="border:none;"
        frameborder="0"
      />
    </Column>
  </Row>
  <Row>
    <Column>
      <div>&nbsp;</div>
    </Column>
  </Row>
  <Row>
    <Column>
      <p class="bx--label">Preview</p>
      <Tile>
        {#if preview}
          {@html preview}
        {/if}
      </Tile>
    </Column>
  </Row>
</Grid>

<style>
</style>
